import AnalyticsService from '@emcd-shared/analytics-service'
import { captureApiError } from '@/shared/lib/captureApiError'
import { b2bApiClient } from '@/shared/api/b2b-client'

function initState() {
  return {
    id: null,
    partnerType: null,
    products: [],
    isLoaded: false,
    isLoading: false,
  }
}

const state = initState()

const mutations = {
  SET_PARTNER_INFO(state, payload) {
    state.id = payload.id
    state.partnerType = payload.partner_type
    state.products = payload.products || []
    state.isLoaded = true
  },

  SET_LOADING(state, value) {
    state.isLoading = value
  },

  RESET_PARTNER_INFO(state) {
    Object.assign(state, initState())
  },
}

const actions = {
  async fetchPartnerInfo({ commit, state }) {
    if (state.isLoading) {
      return
    }

    try {
      commit('SET_LOADING', true)
      AnalyticsService.addBreadcrumb('PartnerStore', 'fetchPartnerInfo')

      const response = await b2bApiClient.getClient().get('/partners')

      commit('SET_PARTNER_INFO', response)
      AnalyticsService.addBreadcrumb('PartnerStore', 'fetchPartnerInfo success')

      return response
    } catch (error) {
      console.error('fetchPartnerInfo error:', error)
      captureApiError('fetchPartnerInfo', '/partners', error)
      AnalyticsService.addBreadcrumb('PartnerStore', 'fetchPartnerInfo error')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  resetPartnerInfo({ commit }) {
    commit('RESET_PARTNER_INFO')
  },
}

const getters = {
  isProductAvailable: (state) => (productName) => {
    if (!state.isLoaded) {
      return true
    }
    return state.products.includes(productName)
  },

  hasAnyProducts(state) {
    return state.products.length > 0
  },

  partnerId(state) {
    return state.id
  },

  partnerType(state) {
    return state.partnerType
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
